import React, { useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import {
  Button,
  Chip,
  DialogBody,
  DialogHeader,
  IconButton,
  Tooltip,
  Typography,
} from '@material-tailwind/react';
import LinearProgress from '@mui/material/LinearProgress';
import { overflowMui } from '../ThemeMode/stylesMui';
import TableNotFound from './TableNotFound';
import { convertToInt } from '../../hook/convertQuantidade';
import { Dialog, MenuItem, Select } from '@mui/material';
import { Info, Pencil } from 'lucide-react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { statusEstoque } from '../../pages/AlertEstoque/AlertEstoque';
import { useDispatch, useSelector } from 'react-redux';
import { getEstoqueBaixo, postStatusEstoqueBaixo } from '../../slices/productSlice';
import { ProdutoModalInfo } from '../Modal/ProdutoModalInfo';

export default function TableMuitFaltaEstoque({ columns, rows, search, loading, status }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [modal, setModal] = React.useState(false);
  const [modalView, setModalView] = React.useState(false);
  const [produtoView, setProdutoView] = React.useState(false);
  const [produto, setProduto] = React.useState(false);
  const { productos } = useSelector((state) => state.product);

  const handleViewProduct = (produto) => {
    const view = productos.find((item) => item.winthor === produto.winthor);
    setProdutoView(view);
  };

  const activeModal = (produto) => {
    setProduto(produto);
    setModal(true);
  };

  useEffect(() => {
    setPage(0);
  }, [search]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <>
      <Paper
        sx={{
          width: '100%',
          height: '100%',
          overflow: 'auto',
        }}
      >
        <TableContainer
          sx={{
            maxHeight: '90%',
            height: '100%',
            minWidth: 600,
            ...overflowMui(),
          }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell width={column === 'Produto' ? '350' : '100'}>{column}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (
                <TableRow>
                  <TableCell colSpan={4}>
                    <LinearProgress />
                  </TableCell>
                </TableRow>
              )}
              {rows.length === 0 && !loading && <TableNotFound />}
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow hover role="row" tabIndex={-1} key={index}>
                    <TableCell>
                      <Typography className="font-bold" onClick={() => handleViewProduct(row)}>
                        {row.nome}
                      </Typography>
                      <Typography className="font-normal text-xs">{row.winthor}</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography className="font-bold">
                        <Chip
                          value={convertToInt(row.quantidade_total)}
                          variant="ghost"
                          className="inline font-bold"
                        />
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography className="font-bold">
                        {convertToInt(row.estoqueMinimo)} // {convertToInt(row.estoqueMaximo)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>
                        <Chip
                          value={row.statusEstoque}
                          className="text-center inline"
                          color={
                            row.statusEstoque === 'Baixo'
                              ? 'red'
                              : row.statusEstoque === 'Email'
                              ? 'blue'
                              : 'green'
                          }
                        />
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <div className="flex gap-x-2">
                        <Pencil
                          color="red"
                          className="cursor-pointer"
                          onClick={() => activeModal(row)}
                        />
                        <Tooltip content={row.motivoDeCompra} className="ml-2">
                          <Info color="blue" />
                        </Tooltip>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`} item`
          }
          labelRowsPerPage="Por página:"
        />
      </Paper>
      <MoldaChoice modal={modal} handleModal={() => setModal(!modal)} produto={produto} />
      <ProdutoModalInfo
        produto={produtoView}
        handleProduto={() => {
          setModalView(!modalView), setProdutoView(false);
        }}
      />
    </>
  );
}

function MoldaChoice({ modal, handleModal, produto }) {
  const [value, setValue] = React.useState(produto.statusEstoque);
  const dispatch = useDispatch();

  const handleChoiceStatus = () => {
    dispatch(postStatusEstoqueBaixo({ status: value, pk: produto.winthor }));
    setTimeout(() => {
      dispatch(getEstoqueBaixo());
    }, [500]);
    handleModal();
  };

  return (
    <Dialog size="lg" open={modal} onClose={handleModal}>
      <DialogHeader className="relative m-0 block min-w-[500px] bg-lightMenu dark:bg-none dark:bg-darkColorBg">
        <Typography variant="h4" className="text-black dark:text-darkText">
          {produto.nome}
        </Typography>
        <IconButton size="sm" variant="text" className="!absolute right-3.5 top-3.5">
          <XMarkIcon className="h-4 w-4 stroke-2 dark:text-darkText" onClick={handleModal} />
        </IconButton>
      </DialogHeader>
      <DialogBody className="space-y-4 pb-6">
        <Select
          defaultValue={produto.statusEstoque}
          onChange={(e) => setValue(e.target.value)}
          className="w-full"
          displayEmpty
        >
          {statusEstoque.map((item, index) => (
            <MenuItem key={index} value={item.status}>
              {item.status}
            </MenuItem>
          ))}
        </Select>
        <div className="flex justify-end">
          <Button color="blue" onClick={handleChoiceStatus}>
            Salvar
          </Button>
        </div>
      </DialogBody>
    </Dialog>
  );
}
